<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-27 15:19:54
 * @FilePath: /wemeet-admin-new/src/views/brand/components/addCategoryItem.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="formRef" inline label-width="80px" :model="form">
      <el-form-item label="添加类目" prop="categoryName">
        <el-input v-model="form.categoryName" clearable maxlength="20" placeholder="请输入，名称不可超过20个字符" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSave">添加</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column label="序号" type="index" width="55" />
      <el-table-column label="类目名称" prop="name" />
      <el-table-column label="操作" show-overflow-tooltip>
        <template #default="{ row }">
          <el-button plain type="info" @click="batchEnterprise(row)">批量关联机构</el-button>
          <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSaveConfirm">提交</el-button>
    </div>

    <el-drawer
      ref="drawerRef"
      v-model="dialogFormVisible1"
      :before-close="handleClose1"
      custom-class="demo-drawer userInfoDrawer"
      :direction="direction"
      :size="size1"
      :title="title1"
    >
      <el-form :label-width="80">
        <el-form-item label="关联机构">
          <el-select
            v-model="checkList"
            clearable
            collapse-tags
            filterable
            multiple
            placeholder="请选择"
            :props="transferPop"
            size="large"
            style="width: 100%"
          >
            <el-option
              v-for="item in allEnterPriseList"
              :key="item.exhibitorCode"
              :label="item.exhibitorName"
              :value="item.exhibitorCode"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSaveFunc">提交</el-button>
      </div>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, reactive, toRefs, computed } from 'vue'
  import { parseTime } from '@/utils/index'
  import Bus from '@/utils/bus'
  import {
    addEnterpriseCategory,
    delEnterpriseCategory,
    queryEnterpriseCategory,
    queryExhibitorByCategoryId,
    batchAddExhibitor,
  } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        dialogFormVisible1: false,
        size1: '50%',
        title: '',
        form: {
          categoryName: '',
        },
        subform: {
          id: '',
        },
        rules1: {
          id: [{ required: true, trigger: 'change', message: '请选择要关联的类目' }],
        },
        checkUserList: [],
        categoryGroupId: '',
        list: [],
        listLoading: false,
        allItem: [],
        checkList: [],
        allEnterPriseList: [],
        subFormRef: null,
        checkRow: {},
        transferPop: {
          value: 'exhibitorCode',
          label: 'exhibitorName',
        },
      })

      const title1 = computed(() => `${state.checkRow.name} 关联机构`)

      // 打开
      const handleOpen = async (row) => {
        state.title = '配置类目'
        state.form = JSON.parse(JSON.stringify(row))
        state.categoryGroupId = state.form.id
        fetchData()
        state.dialogFormVisible = true
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await queryEnterpriseCategory({
          categoryGroupId: state.categoryGroupId,
        })
        state.list = data

        state.listLoading = false
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = async () => {
        try {
          if (state.form.categoryName === '') {
            proxy.$baseMessage(`请输入内容`, 'error', 'vab-hey-message-error')
            return false
          }
          state.form.categoryGroupId = state.categoryGroupId
          state.form.name = state.form.categoryName
          await addEnterpriseCategory(state.form)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          fetchData()
        } catch (e) {
          console.log(e)
        }
      }

      const handleSaveConfirm = () => {
        emit('fetch-data')
        handleClose()
      }

      const handleSelectionChange = (e) => {
        console.log(e)
        state.checkUserList = e
      }

      const handleDelete = (row) => {
        if (row.categoryGroupId) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delEnterpriseCategory(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const batchEnterprise = (row) => {
        state.checkRow = row
        state.dialogFormVisible1 = true
        getEnterpriseList()
      }

      const getEnterpriseList = async () => {
        const { data } = await queryExhibitorByCategoryId({
          categoryId: state.checkRow.id,
        })

        state.checkList = data.filter((e) => e.status).map((v) => v.exhibitorCode)

        state.allEnterPriseList = data
      }

      const handleSaveFunc = async () => {
        try {
          console.log(state.checkList)
          state.checkList = state.checkList.filter((v) => v != '' && v != null && v != undefined && v != 'undefined')
          let params = {
            categoryId: state.checkRow.id,
            enterpriseCodes: state.checkList,
          }
          await batchAddExhibitor(params)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          handleClose1()
          Bus.$emit('fetch-data')
        } catch (error) {}
      }

      const handleClose1 = () => {
        state.subform = {}
        state.dialogFormVisible1 = false
      }

      return {
        ...toRefs(state),
        title1,
        handleOpen,
        handleClose,
        handleDate,
        handleSelectionChange,
        handleSave,
        handleSaveConfirm,
        handleDelete,
        batchEnterprise,
        getEnterpriseList,
        handleSaveFunc,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }

  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .margin-top {
    margin-top: 20px;
  }
</style>
